import angular from 'angular';
import '../../services/organization-condition';
import '../../services/errors';
import { cloneDeep } from 'lodash';

const module = angular.module('whyline.modals.organization-condition', [
  'whyline.services.organization-condition',
  'whyline.services.errors',
]);

const OrganizationConditionModalController = (
  $scope,
  $timeout,
  $state,
  $uibModalInstance,
  $translate,
  GlobalsService,
  NotificationService,
  OrganizationConditionService,
  organizationConditionId,
  ErrorService,
) => {
  'ngInject';

  $scope.blockSaveButton = false;

  $scope.string = { conditionString: '' };

  $scope.condition = {
    slug: '',
    condition: [],
    description: '',
  };

  if (organizationConditionId) {
    OrganizationConditionService.GetOneAsPromiseFromServer(organizationConditionId).then(
      (condition) => {
        $timeout(() => {
          $scope.condition = cloneDeep(condition);
          $scope.string.conditionString = JSON.stringify(condition.condition);
        });
      },
    );
  }

  const validate = () => {
    if (!$scope.condition.slug) {
      NotificationService.Warning($translate.instant('slug_required'));
      return false;
    }

    if (!$scope.string.conditionString) {
      NotificationService.Warning($translate.instant('condition_required'));
      return false;
    }

    if ($scope.condition.slug.length > 56) {
      NotificationService.Warning($translate.instant('condition_name_max_length'));
      return false;
    }

    if (/[!-\/:-@[-`{-~]/.test($scope.condition.slug)) {
      NotificationService.Warning($translate.instant('char_forbidden_name'));
      return false;
    }

    try {
      const parsed = $scope.string.conditionString.replace(/'/g, '"');
      const condition = JSON.parse(parsed);
      if (!Array.isArray(condition)) {
        NotificationService.Warning($translate.instant('condition_must_be_array'));
        return false;
      } else if (condition.length === 0) {
        NotificationService.Warning($translate.instant('empty_condition'));
        return false;
      } else if ($scope.string.conditionString.length > 10000) {
        NotificationService.Warning($translate.instant('condition_max_char'));
        return false;
      }
      $scope.string.conditionString = parsed;
    } catch (err) {
      NotificationService.Warning($translate.instant('condition_wrong_format'));
      console.log('condition error =>', err);
      return false;
    }

    return true;
  };

  $scope.close = () => {
    $uibModalInstance.close('cancel');
  };

  $scope.save = () => {
    if (validate()) {
      const { slug } = $scope.condition;
      $scope.blockSaveButton = true;
      $scope.condition.condition = JSON.parse($scope.string.conditionString);
      let message = '';
      let promise = null;
      if (organizationConditionId) {
        message = $translate.instant('condition_update_succ');
        promise = OrganizationConditionService.Update($scope.condition);
      } else {
        message = $translate.instant('condition_create_succ');
        promise = OrganizationConditionService.Create($scope.condition);
      }

      promise.then(() => {
        NotificationService.Success(message);

        $uibModalInstance.close('cancel');
      });

      return promise.catch((err) => {
        $scope.blockSaveButton = false;

        if (err && err.status === 406) {
          const { data: reason } = err;

          const message = $translate.instant(reason);

          NotificationService.Warning(message);
        } else if (err && err.status === 409) {
          const {
            data: {
              error: { references },
            },
          } = err;

          const message = `La condición contiene referencias que no existen en la organizacion: [${references.join(', ')}]`;

          NotificationService.Warning(message);
        } else {
          ErrorService.handler(err);
        }
      });
    }
  };
};

module.exports = module.controller(
  'OrganizationConditionModalController',
  OrganizationConditionModalController,
);
